import axios from 'axios';

export const getMessages = (jobGuid) => {
  return axios.get(`/notifier/${jobGuid}`).then((response) => response.data);
};

export const getTooLargeMessage = ({ actionId, uniqueMessageId }) => {
  return axios.get(`/notifier/${actionId}?uniqueId=${uniqueMessageId}`).then((response) => response.data);
};
